import React from 'react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { IParentPlayerAssessment } from '../../../lib/types';
import { parentPlayerPath, parentReportCardPath } from '../../../lib/helpers/parent-links.helpers';
import { ProfileLink, ProfileRowDisabled, RowSecondary } from './parent-player-group-card.styles';
import { RowContents } from './row-contents.component';
import { ReportCardAffordance } from './report-card-affordance.component';

interface IAssessmentRowProps {
  row: IParentPlayerAssessment;
  playerName?: string;
}

// The parent's JWT is the credential on this path (no URL token). A row only
// reaches the client once its assessment resolved, so `code` is the gate.
const rowPath = (row: IParentPlayerAssessment) =>
  row.code ? parentPlayerPath(row.code, row._id) : null;

// Report-card route (parent JWT authenticates server-side). reportCardDataId is non-null only
// while the report card is available, so a withheld one gets no link rather than an error.
const reportCardPath = (row: IParentPlayerAssessment) =>
  (row.code && row.reportCardDataId) ? parentReportCardPath(row.code, row._id) : null;

export const AssessmentRow: React.FC<IAssessmentRowProps> = ({ row, playerName }) => {
  const path = rowPath(row);
  const rcPath = reportCardPath(row);
  if (!path) {
    return (
      <ProfileRowDisabled>
        <RowContents row={row} />
        <RowSecondary>No access yet</RowSecondary>
      </ProfileRowDisabled>
    );
  }
  return (
    <ProfileLink to={path}>
      <RowContents row={row} />
      {rcPath && <ReportCardAffordance to={rcPath} playerName={playerName} />}
      <ChevronRightIcon />
    </ProfileLink>
  );
};
